<template>
  <div>
    <div class="card mb-25 border-0 rounded-0 mb-20">
      <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
        <div
          class="mb-15 mb-sm-0 d-sm-flex align-items-center justify-content-between"
        >
          <div class="title">
            <h5 class="card-title fw-black mb-20">{{ formColis.code }}</h5>
          </div>
        </div>
        <form>
          <div class="row">
            <template v-if="row.invoiced != 1">
              <template
                v-if="auth.can('PARCELS') && auth.can('EDIT_FEES_PARCELS')"
              >
                <div
                  class="col-12 col-md-4"
                  v-if="auth.can('PARCELS') && auth.can('EDIT_FEES_PARCELS')"
                >
                  <div class="form-group">
                    <label for="fl">Frais de livraison *</label>
                    <input
                      type="text"
                      class="form-control"
                      style="color: #f14d12"
                      id="fl"
                      v-model="formColis.delivered_fees"
                      :disabled="
                        row.invoiced == 1 ||
                        (row.status == 'DELIVERED' &&
                          (row.situation == 'Facturé' || row.invoiced == 1))
                      "
                    />
                  </div>
                </div>
                <div
                  class="col-12 col-md-4"
                  v-if="auth.can('PARCELS') && auth.can('EDIT_FEES_PARCELS')"
                >
                  <div class="form-group">
                    <label for="frn">Frais de retour *</label>
                    <input
                      type="text"
                      class="form-control"
                      style="color: #f14d12"
                      id="frn"
                      v-model="formColis.returned_fees"
                      :disabled="
                        row.invoiced == 1 ||
                        (row.status == 'DELIVERED' &&
                          (row.situation == 'Facturé' || row.invoiced == 1))
                      "
                    />
                  </div>
                </div>
                <div
                  class="col-12 col-md-4"
                  v-if="auth.can('PARCELS') && auth.can('EDIT_FEES_PARCELS')"
                >
                  <div class="form-group">
                    <label for="frs">Frais de refus *</label>
                    <input
                      type="text"
                      class="form-control"
                      style="color: #f14d12"
                      id="frs"
                      v-model="formColis.refused_fees"
                      :disabled="
                        row.invoiced == 1 ||
                        (row.status == 'DELIVERED' &&
                          (row.situation == 'Facturé' || row.invoiced == 1))
                      "
                    />
                  </div>
                </div>
              </template>
            </template>
            <div class="col-12">
              <hr />
            </div>
            <div class="col-12">
              <button
                v-if="auth.can('PARCELS')"
                type="button"
                class="btn btn-primary mb-1 mb-sm-0 mr-0 mr-sm-1 float-right"
                :disabled="loading"
                @click="AddColis"
              >
                Enregistrer
                <span
                  v-if="loading"
                  class="spinner-border spinner-border-sm"
                ></span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, reactive, watch, onMounted } from "vue";
import moment from "moment";
import api from "@/utils/axios";
import { useAppToast } from "@/composables/useAppToast";
import { useGlobalStore } from "@/stores/global";
import { useAuthStore } from "@/stores/auth";

export default {
  name: "HistoryColis",

  props: {
    rowColis: {
      type: Object,
      required: true,
    },
    getRecords: {
      type: Function,
      required: true,
    },
    isOpenFees: {
      type: Boolean,
    },
    hideModal: {
      type: Function,
      required: true,
    },
  },

  setup: (props) => {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    const detailsColis = ref([]);
    const detailsCalls = ref([]);

    const formColis = reactive({
      id: 0,
      code: "",
      delivered_fees: "",
      returned_fees: "",
      refused_fees: "",
    });

    const loading = ref(false);
    const globalStore = useGlobalStore();

    function getDate(value: string) {
      return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
    }

    async function AddColis() {
      const data = new FormData();
      data.append("delivered_fees", formColis.delivered_fees);
      data.append("returned_fees", formColis.returned_fees);
      data.append("refused_fees", formColis.refused_fees);
      loading.value = true;
      try {
        const res = await api.post(
          `/api/auth/coli_edit_fees/${formColis.id}`,
          data
        );
        loading.value = false;
        if (res.data.message === "success") {
          props.getRecords();
          // globalStore.hideModal("modal-fees-edit");
          showToast("Les données sont bien sauvegardés", "success");
          props.hideModal("modal_fees_edit");
        } else if (
          res.data.message === "no edit" ||
          res.data.message === "no access"
        ) {
          showToast("Vous pouvez pas modifier ce colis", "error");
        } else if (res.data.message === "error replace") {
          showToast("Code colis à changer est invalide", "error");
        }
      } catch (error) {
        showToast("Something went wrong! Please try again", "error");
        loading.value = false;
      }
    }

    onMounted(async () => {
      console.log("open ", props.isOpenFees);
      if (props.isOpenFees) {
        Object.assign(formColis, props.rowColis);
      }
    });
    const row = ref<any>({});
    watch(
      () => props.isOpenFees,
      (newVal) => {
        console.log("isOpenFees changed:", newVal);
        if (newVal) {
          if (props.isOpenFees) {
            Object.assign(formColis, props.rowColis);
          }
          row.value = props.rowColis;
          console.log("row edit", row.value);
        }
      },
      { immediate: true }
    );

    return {
      detailsColis,
      detailsCalls,
      loading,
      formColis,
      getDate,
      row,
      auth,
      user,
      AddColis,
      globalStore,
    };
  },
};
</script>
